import { useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa6";

const PHONE = "393890023631";
const MESSAGE = "Ciao Fabio! Ti scrivo dal Cassetto delle Giraffe.";

export const WhatsAppButton = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname.startsWith("/accedi")) return null;

  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrivimi su WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 hover:scale-110 hover:bg-[#20bd5a] transition-transform duration-200"
    >
      <FaWhatsapp size={28} />
    </a>
  );
};
